import React, { useEffect, useState } from "react";
import { Form, Input, Switch, message, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import CustomModal from "../../../../../../shared/util/AntModal/CustomModal";
import TenantProvider from "../../../../../../shared/provider/TenantProvider";
import { TenantDto } from "../../../../../../shared/dto/TenantDto";
import styled from "styled-components";
import AlertModal from "../../../../../../shared/util/AntModal/AlertModal";

interface AddEditTenantProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  fetchTenants: () => void;
  tenant?: TenantDto | null;
}

const RequiredLabel = styled.span`
  color: black;
  margin-left: 4px;
`;

const AddEditTenant: React.FC<AddEditTenantProps> = ({ open, setOpen, fetchTenants, tenant }) => {
  const [form] = Form.useForm();
  const tenantProvider = new TenantProvider();
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (tenant) {
      form.setFieldsValue(tenant);
    } else {
      form.resetFields();
    }
  }, [tenant, form]);

  const handleSubmit = async (values: TenantDto) => {
    setLoading(true);
    setErrorMessage("");
    try {
      if (tenant) {
        await tenantProvider.update(tenant.tenantId, values);
      } else {
        await tenantProvider.create(values);
      }
      fetchTenants();
      setSuccessModalVisible(true);
    } catch (error: any) {
      console.log({error, test: error && error.response && error.response.data && error.response.data.messages && error.response.data.messages.filter((message: string) => message.includes("ET001")).length > 0})
      if (error && error.response && error.response.data && error.response.data.messages && error.response.data.messages.filter((message: string) => message.includes("ET001")).length > 0) {
        setErrorMessage("Já existe um tenant com este nome");
      }
      else {
        setErrorMessage("Erro ao salvar tenant");
      }

      console.error("Erro ao salvar tenant:", error);
    } finally {
      setLoading(false);
    }
  };

  const closeAllModals = () => {
    setSuccessModalVisible(false);
    setErrorMessage("");
    setOpen(false);
    form.resetFields();
  };

  return (
    <CustomModal
      title={tenant ? "Editar Tenant" : "Adicionar Tenant"}
      visible={open}
      onCancel={() => setWarningModalVisible(true)}
      onConfirm={() => form.submit()}
      confirmText="Salvar Tenant"
      successMessage={tenant ? "Tenant editado com sucesso." : "Tenant criado com sucesso."}
      footer={null}
      showWarning={warningModalVisible}
      showSuccess={successModalVisible}
      onWarningConfirm={() => {
        setWarningModalVisible(false);
        setOpen(false);
        form.resetFields();
      }}
      onWarningCancel={() => setWarningModalVisible(false)}
      onSuccessConfirm={closeAllModals}
    >
      <AlertModal
        title="Atenção"
        visible={errorMessage.length > 0}
        onCancel={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        confirmText="Ok"
        showCancelButton={false}
      >
        Ja existe um tenant com este nome
        </AlertModal>
      <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
        <Form.Item
          name="name"
          label={<b>Nome do locatário<RequiredLabel>*</RequiredLabel>:</b>}
          rules={[{ required: true, message: "Por favor, insira o nome do locatário" }]}
        >
          <Input placeholder="Digite aqui" disabled={tenant?.tenantId === 1} />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Form.Item
            name="managerName"
            label={<b>Nome do gerente:</b>}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input placeholder="Digite aqui" />
          </Form.Item>
          <Form.Item
            name="managerEmail"
            label={<b>Email do gerente:</b>}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginLeft: '16px' }}
          >
            <Input placeholder="Digite aqui" />
          </Form.Item>
        </Form.Item>

        <Form.Item
          name="domain"
          label={<b>Domínio:</b>}
        >
          <Input placeholder="Digite aqui" />
        </Form.Item>

        <Form.Item>
            <Form.Item
            name="active"
            label={<b>Ativo:</b>}
            valuePropName="checked"
            initialValue={tenant ? tenant.active : false}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
            >
            <Switch checkedChildren="Ativo" unCheckedChildren="Inativo" disabled={tenant?.tenantId === 1} />
            </Form.Item>
        </Form.Item>
      </Form>
    </CustomModal>
  );
};

export default AddEditTenant;
